import logo from "../assets/images/logo/Trellis_Logomark_color.png";
import PerfectScrollbar from "react-perfect-scrollbar";
import AdminNavbarLinks from "./NavigationBar";
import ProductOptions from "./sidebar/ProductOptions";
import MerchantSidebar from "./sidebar/MerchandisingSidebar";
import MobileNavbarTiles from "../components/custom/navbar/MobileNavbarTiles";
import { Button } from "../components/core/basic/Button";
import { logoutUser } from "../redux/reducers/userReducer";
import { HOMEPAGE } from "../utils/redirectConstants";
import { DatesProvider } from "../dates/DatesContext";
import { useAppDispatch } from "../redux/hooks";
import { useWindowSize } from "@reactuses/core";
import { css, cx } from "../../styled-system/css";
import { useTranslation } from "react-i18next";

function Sidebar() {
  const dispatch = useAppDispatch();
  const { width } = useWindowSize();
  const { t } = useTranslation(["common"]);

  const onLogoutClick = () => {
    dispatch(logoutUser());
  };

  return (
    <DatesProvider>
      <div className="sidebar" data-color="gv-light">
        <div className={cx(css({ zIndex: "stickyBar", backgroundColor: "#F5F3F6" }), "logo d-flex border-bottom")}>
          <div className={`text-center ${width <= 992 ? "me-auto" : "mx-auto"}`}>
            <a href={HOMEPAGE} className="simple-text logo-mini" target="_blank" rel="noopener noreferrer">
              <div className="logo-img">
                <img src={logo} alt={t(($) => $.common.sidebar["Trellis logo"])} />
              </div>
            </a>
            <a
              href={HOMEPAGE}
              className="simple-text logo-normal"
              target="_blank"
              rel="noopener noreferrer"
              style={{ width: "120px" }}
            >
              <div
                style={{
                  textTransform: "lowercase",
                  fontSize: "24px",
                  fontWeight: "bolder",
                  color: "#2e0054",
                  marginRight: "20px",
                  paddingTop: ".7rem",
                }}
              >
                {t(($) => $.common.sidebar.trellis)}
              </div>
            </a>
          </div>
          {width <= 992 && (
            <div
              className={css({
                zIndex: "stickyBar",
                position: "absolute",
                top: "22px",
                right: "100px",
              })}
            >
              <Button onPress={onLogoutClick}>{t(($) => $.common.Logout)}</Button>
              <span
                onClick={() => document.documentElement.classList.toggle("nav-open")}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  color: "#2e0054",
                  position: "fixed",
                  top: "15px",
                  right: "25px",
                  cursor: "pointer",
                  fontSize: "2rem",
                  fontWeight: 700,
                }}
              >
                &#10005;
              </span>
            </div>
          )}
        </div>

        <PerfectScrollbar
          className={`sidebar-wrapper`}
          style={{
            background: "#F5F3F6",
          }}
          options={{ suppressScrollX: true }}
        >
          <ProductOptions />

          <ul className="nav">
            {/*
              If we are on responsive, we want both links from navbar and sidebar
              to appear in sidebar, so we render here HeaderLinks
            */}
            {width <= 992 ?
              <>
                <AdminNavbarLinks />
                <MobileNavbarTiles />
              </>
            : null}
            <MerchantSidebar />
          </ul>
        </PerfectScrollbar>
      </div>
    </DatesProvider>
  );
}

export default Sidebar;
